// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var ThankYou$ReactHooksTemplate = require("./ThankYou.res.js");
var SurveyTheme$ReactHooksTemplate = require("./surveyTheme.res.js");
var Substitution$ReactHooksTemplate = require("../common/Substitution.res.js");
var RedirectionUrl$ReactHooksTemplate = require("./redirectionUrl.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");

function ThankYouForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var verificationCode = props.verificationCode;
  var redirectionDescription = props.redirectionDescription;
  var __redirectionType = props.redirectionType;
  var redirectionDelay = props.redirectionDelay;
  var redirectionUrl = props.redirectionUrl;
  var thankYou = props.thankYou;
  var redirectionType = __redirectionType !== undefined ? __redirectionType : "automatic";
  var langName = SurveyLanguage$ReactHooksTemplate.name(props.language);
  var titleHtml = Substitution$ReactHooksTemplate.renderQuestionText(ThankYou$ReactHooksTemplate.title(thankYou), substitutionVariables);
  var textHtml = Substitution$ReactHooksTemplate.renderQuestionText(ThankYou$ReactHooksTemplate.getTextTranslation(thankYou, langName), substitutionVariables);
  var match = React.useState(function (param) {
        return false;
      });
  var setCopied = match[1];
  var copied = match[0];
  var redirectionToUrl = function (redUrl) {
    console.log(redUrl);
    if (redUrl !== undefined) {
      window.location.href = RedirectionUrl$ReactHooksTemplate.url(redUrl);
      return ;
    }
    
  };
  React.useEffect((function (param) {
          if (redirectionType !== "automatic") {
            return ;
          }
          if (redirectionUrl === undefined) {
            return ;
          }
          var timerId = setTimeout((function (param) {
                  redirectionToUrl(redirectionUrl);
                }), redirectionDelay);
          return (function (param) {
                    clearTimeout(timerId);
                  });
        }), []);
  var urlPath = ThankYou$ReactHooksTemplate.image(thankYou);
  var tmp;
  if (verificationCode !== undefined) {
    var len = verificationCode.length;
    var displayCode = len > 16 ? Js_string.slice(0, 8, verificationCode) + "..." + Js_string.sliceToEnd(len - 6 | 0, verificationCode) : verificationCode;
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("span", {
                                children: displayCode,
                                className: "text-sm font-mono tracking-wide transition-colors duration-200\n                          " + (
                                  copied ? "text-emerald-700" : "text-gray-600"
                                )
                              }),
                          JsxRuntime.jsx("svg", {
                                children: copied ? JsxRuntime.jsx("path", {
                                        d: "M5 13l4 4L19 7",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: "2"
                                      }) : JsxRuntime.jsx("path", {
                                        d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: "2"
                                      }),
                                className: "w-14-px h-14-px transition-colors duration-200\n                          " + (
                                  copied ? "text-emerald-500" : "text-gray-400 group-hover:text-gray-500"
                                ),
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              })
                        ],
                        className: "inline-flex items-center gap-8-px px-16-px py-10-px rounded-lg\n                        border transition-all duration-200\n                        " + (
                          copied ? "bg-emerald-50 border-emerald-300" : "bg-gray-50 border-gray-200 hover:bg-gray-100 hover:border-gray-300"
                        )
                      }),
                  className: "group cursor-pointer select-none",
                  onClick: (function (param) {
                      navigator.clipboard.writeText(verificationCode);
                      Curry._1(setCopied, (function (param) {
                              return true;
                            }));
                      setTimeout((function (param) {
                              Curry._1(setCopied, (function (param) {
                                      return false;
                                    }));
                            }), 2000);
                    })
                }),
            copied ? JsxRuntime.jsx("p", {
                    children: "Copied!",
                    className: "mt-8-px text-xs text-emerald-600"
                  }) : null
          ],
          className: "mt-24-px flex flex-col items-center"
        });
  } else {
    tmp = null;
  }
  var tmp$1;
  if (redirectionUrl !== undefined) {
    var tmp$2;
    if (redirectionDescription !== undefined) {
      var descriptionHtml = Substitution$ReactHooksTemplate.renderQuestionText(redirectionDescription, substitutionVariables);
      tmp$2 = JsxRuntime.jsx("div", {
            className: "survey-rich-text mb-16-px text-base text-center text-gray-700 small:text-sm max-w-sm px-20-px",
            dangerouslySetInnerHTML: {
              __html: descriptionHtml
            }
          });
    } else {
      tmp$2 = null;
    }
    var tmp$3;
    switch (redirectionType) {
      case "automatic" :
          tmp$3 = JsxRuntime.jsx("p", {
                children: "Redirecting...",
                className: "text-sm text-gray-500 animate-pulse"
              });
          break;
      case "manual" :
          var buttonColor = Belt_Option.mapWithDefault(props.theme, "#3B82F6", SurveyTheme$ReactHooksTemplate.nextButtonColor);
          tmp$3 = JsxRuntime.jsx("button", {
                children: Belt_Option.getWithDefault(props.redirectionButtonText, "Continue"),
                className: "px-32-px py-14-px text-white font-semibold rounded-lg shadow-lg\n                       transition-all duration-200 text-base leading-6\n                       hover:shadow-xl hover:opacity-90 transform hover:scale-105\n                       focus:outline-none focus:ring-4 focus:ring-opacity-50",
                style: {
                  backgroundColor: buttonColor
                },
                onClick: (function (param) {
                    redirectionToUrl(redirectionUrl);
                  })
              });
          break;
      default:
        tmp$3 = null;
    }
    tmp$1 = JsxRuntime.jsxs("div", {
          children: [
            tmp$2,
            tmp$3
          ],
          className: "mt-32-px flex flex-col items-center"
        });
  } else {
    tmp$1 = null;
  }
  return JsxRuntime.jsxs("div", {
              children: [
                urlPath !== undefined ? JsxRuntime.jsx("img", {
                        className: "w-full h-275-px small:h-200-px mb-48-px",
                        src: window.location.origin + urlPath
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                JsxRuntime.jsx("div", {
                      className: "survey-rich-text mb-8-px font-semibold text-2xl leading-8 text-center\n      text-black small:text-lg mix-blend-normal",
                      dangerouslySetInnerHTML: {
                        __html: titleHtml
                      }
                    }),
                JsxRuntime.jsx("div", {
                      className: "survey-rich-text pb-16-px font-normal leading-6 text-base text-center small:text-lg tracking-0.8",
                      dangerouslySetInnerHTML: {
                        __html: textHtml
                      }
                    }),
                tmp,
                tmp$1
              ],
              className: "flex flex-col w-full mt-48-px small:mt-40-px"
            });
}

var make = ThankYouForm;

exports.make = make;
/* react Not a pure module */
